var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{ref:"refInsightChartTree",staticClass:"istTreeChart",attrs:{"height":"300","width":"100%","options":_vm.chartOptionsTree,"series":_vm.series}})}
var staticRenderFns = []

export { render, staticRenderFns }